import { Color, Spacing } from '@persona-id/design-tokens';
import { BORDER_RADIUSES, FONT_SIZES } from 'shared/styles/variables';
import styled from 'styled-components';

import { Container, Header, Section } from 'dashboard/layouts/IndexViewLayoutV2';
import Card from 'design-system/components/Card';
import ImageCircleAlert from 'images/dashboard/circle-alert.svg';

const MaintenanceWarningContainer = styled.div``;

const MaintenanceWarning = styled.div`
  display: flex;
  align-items: center;

  background-color: ${Color.CoreYellow200};
  border: 1px solid ${Color.CoreYellow400};
  color: ${Color.PrimaryBlack};

  border-radius: ${BORDER_RADIUSES.rounded};
  padding: ${Spacing[4]};
`;

const MaintenanceIcon = styled.div`
  display: flex;
  margin-right: ${Spacing[2]};
`;

const MaintenanceMessage = styled.div`
  display: flex;
  flex: 1 1 auto;

  font-size: ${FONT_SIZES.small};
`;

const StyledImageCircleAlert = styled(ImageCircleAlert)`
  path {
    stroke: ${Color.PrimaryBlack};
  }
`;

const MAINTENANCE_ICON_DIMENSION = 14;

interface DashboardGraphMaintenanceViewProps {}

const DashboardGraphMaintenanceView = (_props: DashboardGraphMaintenanceViewProps) => {
  return (
    <Container>
      <Header title='Graph' />
      <Section>
        <Card>
          <Card.Body>
            <MaintenanceWarningContainer>
              <MaintenanceWarning>
                <MaintenanceIcon>
                  <StyledImageCircleAlert
                    width={MAINTENANCE_ICON_DIMENSION}
                    height={MAINTENANCE_ICON_DIMENSION}
                  />
                </MaintenanceIcon>
                <MaintenanceMessage>
                  Graph is currently undergoing maintenance. Please check back in a few minutes.
                </MaintenanceMessage>
              </MaintenanceWarning>
            </MaintenanceWarningContainer>
          </Card.Body>
        </Card>
      </Section>
    </Container>
  );
};

export default DashboardGraphMaintenanceView;
